import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Render app immediately for optimal LCP
const root = document.getElementById("root")!;
const appRoot = createRoot(root);
appRoot.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Detect if mobile and optimize accordingly
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// Defer non-critical optimizations to idle time
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => {
    if (isMobile) {
      document.documentElement.style.setProperty("--animation-duration", "100ms");
    }
  });
} else {
  setTimeout(() => {
    if (isMobile) {
      document.documentElement.style.setProperty("--animation-duration", "100ms");
    }
  }, 2000);
}
